export const IMAGES = {
  hero: "/images/hero.png",
  story1: "/images/story1.png",
  story2: "/images/story2.png",
  story3: "/images/story3.png",
  peopleWalk: "/images/story3.png",
  blogAnziani: "/images/blogAnziani.png",
  blogSolitudine: "/images/blogSolitudine.png",
  blogFamiglie: "/images/blogFamiglie.png",
};
